import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=bfba451a&scoped=true&"
import script from "./main-header.vue?vue&type=script&lang=js&"
export * from "./main-header.vue?vue&type=script&lang=js&"
import style0 from "./main-header.vue?vue&type=style&index=0&id=bfba451a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfba451a",
  null
  
)

export default component.exports